import { Model } from '@vuex-orm/core';
import PouleModel from './PouleModel';
import MatchModel from './MatchModel';
import { v4 as uuid } from 'uuid';  // https://vuex-orm.github.io/vuex-orm/guide/model/defining-models.html#uid-type and https://github.com/uuidjs/uuid
import {utils} from '../services/utils';

export default class ParticipantModel extends Model {
  static entity = 'participants';

  static fields () {
    return {
      id: this.uid(() => uuid()),
      poule_id: this.string(null).nullable(),
      name: this.string(''),
      info: this.string(''),
      status: this.string(''),
      poule: this.belongsTo(PouleModel, 'poule_id'),
      matches_a: this.hasMany(MatchModel, 'player_a_id'),
      matches_b: this.hasMany(MatchModel, 'player_b_id'),
      created_at: this.attr(null)
    };
  }

  static beforeCreate(model) {
    model.created_at = utils.nowDateString();
  }

  get pouleName () {
    return this.poule_id ? this.poule.name : '';
  }
}
